// src/data/prakritiQuestions.js
// Comprehensive Prakriti Analysis Questionnaire - 40 Questions

const PrakritiQuestions = [
  // PHYSICAL TRAITS (Questions 1-25)
  {
    id: 1,
    category: 'Physical Traits',
    question: 'How would you describe your body frame?',
    options: [
      { text: 'Thin, light, difficulty gaining weight', vata: 3, pitta: 0, kapha: 0 },
      { text: 'Medium build, moderate weight', vata: 0, pitta: 3, kapha: 0 },
      { text: 'Large, heavy, easy weight gain', vata: 0, pitta: 0, kapha: 3 }
    ]
  },
  {
    id: 2,
    category: 'Physical Traits',
    question: 'What is your body weight tendency?',
    options: [
      { text: 'Low, difficult to gain weight', vata: 3, pitta: 0, kapha: 0 },
      { text: 'Moderate, easy to maintain', vata: 0, pitta: 3, kapha: 0 },
      { text: 'Heavy, easy to gain weight', vata: 0, pitta: 0, kapha: 3 }
    ]
  },
  {
    id: 3,
    category: 'Physical Traits',
    question: 'How is your skin texture?',
    options: [
      { text: 'Dry, rough, cool', vata: 3, pitta: 0, kapha: 0 },
      { text: 'Warm, oily, prone to rashes', vata: 0, pitta: 3, kapha: 0 },
      { text: 'Thick, moist, cool, smooth', vata: 0, pitta: 0, kapha: 3 }
    ]
  },
  {
    id: 4,
    category: 'Physical Traits',
    question: 'How would you describe your hair?',
    options: [
      { text: 'Dry, thin, brittle', vata: 3, pitta: 0, kapha: 0 },
      { text: 'Fine, oily, early graying/balding', vata: 0, pitta: 3, kapha: 0 },
      { text: 'Thick, oily, lustrous, wavy', vata: 0, pitta: 0, kapha: 3 }
    ]
  },
  {
    id: 5,
    category: 'Physical Traits',
    question: 'What are your eyes like?',
    options: [
      { text: 'Small, dry, active', vata: 3, pitta: 0, kapha: 0 },
      { text: 'Sharp, bright, sensitive to light', vata: 0, pitta: 3, kapha: 0 },
      { text: 'Large, calm, attractive', vata: 0, pitta: 0, kapha: 3 }
    ]
  },
  {
    id: 6,
    category: 'Physical Traits',
    question: 'How is your appetite?',
    options: [
      { text: 'Irregular, often forget to eat', vata: 3, pitta: 0, kapha: 0 },
      { text: 'Strong, get irritable if miss meals', vata: 0, pitta: 3, kapha: 0 },
      { text: 'Steady, can skip meals easily', vata: 0, pitta: 0, kapha: 3 }
    ]
  },
  {
    id: 7,
    category: 'Physical Traits',
    question: 'How is your digestion?',
    options: [
      { text: 'Irregular, gas, bloating', vata: 3, pitta: 0, kapha: 0 },
      { text: 'Quick, strong, burning sensation', vata: 0, pitta: 3, kapha: 0 },
      { text: 'Slow, forms mucus after eating', vata: 0, pitta: 0, kapha: 3 }
    ]
  },
  {
    id: 8,
    category: 'Physical Traits',
    question: 'How is your thirst level?',
    options: [
      { text: 'Variable, sometimes forget to drink', vata: 3, pitta: 0, kapha: 0 },
      { text: 'Excessive, need frequent water', vata: 0, pitta: 3, kapha: 0 },
      { text: 'Sparse, rarely feel thirsty', vata: 0, pitta: 0, kapha: 3 }
    ]
  },
  {
    id: 9,
    category: 'Physical Traits',
    question: 'How is your bowel movement?',
    options: [
      { text: 'Irregular, tends towards constipation', vata: 3, pitta: 0, kapha: 0 },
      { text: 'Regular, soft, frequent', vata: 0, pitta: 3, kapha: 0 },
      { text: 'Heavy, slow, regular', vata: 0, pitta: 0, kapha: 3 }
    ]
  },
  {
    id: 10,
    category: 'Physical Traits',
    question: 'How is your physical activity level?',
    options: [
      { text: 'Very active, restless', vata: 3, pitta: 0, kapha: 0 },
      { text: 'Moderate, purposeful', vata: 0, pitta: 3, kapha: 0 },
      { text: 'Slow, steady, lethargic', vata: 0, pitta: 0, kapha: 3 }
    ]
  },
  {
    id: 11,
    category: 'Physical Traits',
    question: 'How is your endurance and stamina?',
    options: [
      { text: 'Low, quick to tire', vata: 3, pitta: 0, kapha: 0 },
      { text: 'Moderate, good when motivated', vata: 0, pitta: 3, kapha: 0 },
      { text: 'High, steady energy', vata: 0, pitta: 0, kapha: 3 }
    ]
  },
  {
    id: 12,
    category: 'Physical Traits',
    question: 'How is your sleep pattern?',
    options: [
      { text: 'Light, interrupted, difficulty falling asleep', vata: 3, pitta: 0, kapha: 0 },
      { text: 'Sound but short, wake easily', vata: 0, pitta: 3, kapha: 0 },
      { text: 'Heavy, long, difficulty waking up', vata: 0, pitta: 0, kapha: 3 }
    ]
  },
  {
    id: 13,
    category: 'Physical Traits',
    question: 'How do you feel about weather?',
    options: [
      { text: 'Dislike cold and wind', vata: 3, pitta: 0, kapha: 0 },
      { text: 'Dislike heat and sun', vata: 0, pitta: 3, kapha: 0 },
      { text: 'Dislike cold and dampness', vata: 0, pitta: 0, kapha: 3 }
    ]
  },
  {
    id: 14,
    category: 'Physical Traits',
    question: 'How is your body temperature?',
    options: [
      { text: 'Hands and feet often cold', vata: 3, pitta: 0, kapha: 0 },
      { text: 'Usually warm, perspire easily', vata: 0, pitta: 3, kapha: 0 },
      { text: 'Cool, steady temperature', vata: 0, pitta: 0, kapha: 3 }
    ]
  },
  {
    id: 15,
    category: 'Physical Traits',
    question: 'How is your voice?',
    options: [
      { text: 'Weak, hoarse, breaks', vata: 3, pitta: 0, kapha: 0 },
      { text: 'Sharp, clear, penetrating', vata: 0, pitta: 3, kapha: 0 },
      { text: 'Deep, melodious, pleasant', vata: 0, pitta: 0, kapha: 3 }
    ]
  },
  {
    id: 16,
    category: 'Physical Traits',
    question: 'How do you walk?',
    options: [
      { text: 'Quick, fast-paced', vata: 3, pitta: 0, kapha: 0 },
      { text: 'Determined, purposeful', vata: 0, pitta: 3, kapha: 0 },
      { text: 'Slow, steady, graceful', vata: 0, pitta: 0, kapha: 3 }
    ]
  },
  {
    id: 17,
    category: 'Physical Traits',
    question: 'How are your joints?',
    options: [
      { text: 'Thin, prominent, crack easily', vata: 3, pitta: 0, kapha: 0 },
      { text: 'Moderate, flexible', vata: 0, pitta: 3, kapha: 0 },
      { text: 'Large, well-lubricated, sturdy', vata: 0, pitta: 0, kapha: 3 }
    ]
  },
  {
    id: 18,
    category: 'Physical Traits',
    question: 'How is your menstrual cycle? (For women)',
    options: [
      { text: 'Irregular, scanty, painful', vata: 3, pitta: 0, kapha: 0 },
      { text: 'Regular, profuse, with clots', vata: 0, pitta: 3, kapha: 0 },
      { text: 'Regular, moderate, smooth', vata: 0, pitta: 0, kapha: 3 }
    ]
  },
  {
    id: 19,
    category: 'Physical Traits',
    question: 'How is your resistance to disease?',
    options: [
      { text: 'Low, frequent illness', vata: 3, pitta: 0, kapha: 0 },
      { text: 'Moderate, prone to infections', vata: 0, pitta: 3, kapha: 0 },
      { text: 'High, rarely fall sick', vata: 0, pitta: 0, kapha: 3 }
    ]
  },
  {
    id: 20,
    category: 'Physical Traits',
    question: 'How do you respond to stress physically?',
    options: [
      { text: 'Anxiety, trembling, palpitations', vata: 3, pitta: 0, kapha: 0 },
      { text: 'Anger, heartburn, sweating', vata: 0, pitta: 3, kapha: 0 },
      { text: 'Withdraw, gain weight, sleep more', vata: 0, pitta: 0, kapha: 3 }
    ]
  },
  {
    id: 21,
    category: 'Physical Traits',
    question: 'How are your teeth and gums?',
    options: [
      { text: 'Thin gums, irregular teeth', vata: 3, pitta: 0, kapha: 0 },
      { text: 'Soft gums, yellowish teeth', vata: 0, pitta: 3, kapha: 0 },
      { text: 'Healthy gums, strong white teeth', vata: 0, pitta: 0, kapha: 3 }
    ]
  },
  {
    id: 22,
    category: 'Physical Traits',
    question: 'How is your urine output?',
    options: [
      { text: 'Scanty, colorless', vata: 3, pitta: 0, kapha: 0 },
      { text: 'Profuse, yellow', vata: 0, pitta: 3, kapha: 0 },
      { text: 'Moderate, pale', vata: 0, pitta: 0, kapha: 3 }
    ]
  },
  {
    id: 23,
    category: 'Physical Traits',
    question: 'How is your perspiration?',
    options: [
      { text: 'Minimal, no odor', vata: 3, pitta: 0, kapha: 0 },
      { text: 'Profuse, hot, strong odor', vata: 0, pitta: 3, kapha: 0 },
      { text: 'Moderate, pleasant smell', vata: 0, pitta: 0, kapha: 3 }
    ]
  },
  {
    id: 24,
    category: 'Physical Traits',
    question: 'How are your lips?',
    options: [
      { text: 'Dry, cracked', vata: 3, pitta: 0, kapha: 0 },
      { text: 'Red, inflamed', vata: 0, pitta: 3, kapha: 0 },
      { text: 'Smooth, oily, pale', vata: 0, pitta: 0, kapha: 3 }
    ]
  },
  {
    id: 25,
    category: 'Physical Traits',
    question: 'How is your physical strength?',
    options: [
      { text: 'Low, tire easily', vata: 3, pitta: 0, kapha: 0 },
      { text: 'Medium, strong when motivated', vata: 0, pitta: 3, kapha: 0 },
      { text: 'High, excellent stamina', vata: 0, pitta: 0, kapha: 3 }
    ]
  },

  // MENTAL & BEHAVIORAL TRAITS (Questions 26-40)
  {
    id: 26,
    category: 'Mental Traits',
    question: 'How is your mental activity?',
    options: [
      { text: 'Always active, restless mind', vata: 3, pitta: 0, kapha: 0 },
      { text: 'Sharp, focused, goal-oriented', vata: 0, pitta: 3, kapha: 0 },
      { text: 'Calm, steady, slow to process', vata: 0, pitta: 0, kapha: 3 }
    ]
  },
  {
    id: 27,
    category: 'Mental Traits',
    question: 'How is your memory?',
    options: [
      { text: 'Quick to learn, quick to forget', vata: 3, pitta: 0, kapha: 0 },
      { text: 'Sharp, clear, precise recall', vata: 0, pitta: 3, kapha: 0 },
      { text: 'Slow to learn but never forget', vata: 0, pitta: 0, kapha: 3 }
    ]
  },
  {
    id: 28,
    category: 'Mental Traits',
    question: 'How do you make decisions?',
    options: [
      { text: 'Quickly but often change mind', vata: 3, pitta: 0, kapha: 0 },
      { text: 'Quickly and stick to it', vata: 0, pitta: 3, kapha: 0 },
      { text: 'Slowly after much deliberation', vata: 0, pitta: 0, kapha: 3 }
    ]
  },
  {
    id: 29,
    category: 'Mental Traits',
    question: 'What is your emotional temperament?',
    options: [
      { text: 'Anxious, worried, fearful', vata: 3, pitta: 0, kapha: 0 },
      { text: 'Angry, irritable, jealous', vata: 0, pitta: 3, kapha: 0 },
      { text: 'Calm, attached, greedy', vata: 0, pitta: 0, kapha: 3 }
    ]
  },
  {
    id: 30,
    category: 'Mental Traits',
    question: 'How do you handle stress?',
    options: [
      { text: 'Become anxious and worried', vata: 3, pitta: 0, kapha: 0 },
      { text: 'Become angry and aggressive', vata: 0, pitta: 3, kapha: 0 },
      { text: 'Withdraw and avoid', vata: 0, pitta: 0, kapha: 3 }
    ]
  },
  {
    id: 31,
    category: 'Mental Traits',
    question: 'What is your speaking style?',
    options: [
      { text: 'Fast, talkative, jump topics', vata: 3, pitta: 0, kapha: 0 },
      { text: 'Sharp, precise, argumentative', vata: 0, pitta: 3, kapha: 0 },
      { text: 'Slow, monotonous, meaningful', vata: 0, pitta: 0, kapha: 3 }
    ]
  },
  {
    id: 32,
    category: 'Mental Traits',
    question: 'How is your creativity?',
    options: [
      { text: 'Very creative, artistic', vata: 3, pitta: 0, kapha: 0 },
      { text: 'Inventive, good planner', vata: 0, pitta: 3, kapha: 0 },
      { text: 'Not very creative but practical', vata: 0, pitta: 0, kapha: 3 }
    ]
  },
  {
    id: 33,
    category: 'Mental Traits',
    question: 'How is your concentration?',
    options: [
      { text: 'Poor, easily distracted', vata: 3, pitta: 0, kapha: 0 },
      { text: 'Good when interested', vata: 0, pitta: 3, kapha: 0 },
      { text: 'Excellent, steady focus', vata: 0, pitta: 0, kapha: 3 }
    ]
  },
  {
    id: 34,
    category: 'Mental Traits',
    question: 'What is your learning style?',
    options: [
      { text: 'Learn quickly but need repetition', vata: 3, pitta: 0, kapha: 0 },
      { text: 'Learn moderately, understand deeply', vata: 0, pitta: 3, kapha: 0 },
      { text: 'Learn slowly but retain forever', vata: 0, pitta: 0, kapha: 3 }
    ]
  },
  {
    id: 35,
    category: 'Mental Traits',
    question: 'How do you spend money?',
    options: [
      { text: 'Impulsively, on small things', vata: 3, pitta: 0, kapha: 0 },
      { text: 'Generously, on luxury items', vata: 0, pitta: 3, kapha: 0 },
      { text: 'Carefully, save for future', vata: 0, pitta: 0, kapha: 3 }
    ]
  },
  {
    id: 36,
    category: 'Mental Traits',
    question: 'What is your work style?',
    options: [
      { text: 'Creative, enthusiastic but inconsistent', vata: 3, pitta: 0, kapha: 0 },
      { text: 'Intense, focused, competitive', vata: 0, pitta: 3, kapha: 0 },
      { text: 'Steady, reliable, methodical', vata: 0, pitta: 0, kapha: 3 }
    ]
  },
  {
    id: 37,
    category: 'Mental Traits',
    question: 'How do you respond to change?',
    options: [
      { text: 'Love change and variety', vata: 3, pitta: 0, kapha: 0 },
      { text: 'Accept if beneficial', vata: 0, pitta: 3, kapha: 0 },
      { text: 'Resist change, prefer routine', vata: 0, pitta: 0, kapha: 3 }
    ]
  },
  {
    id: 38,
    category: 'Mental Traits',
    question: 'What is your faith/belief tendency?',
    options: [
      { text: 'Variable, changeable', vata: 3, pitta: 0, kapha: 0 },
      { text: 'Strong convictions, extremist', vata: 0, pitta: 3, kapha: 0 },
      { text: 'Steady, constant, loyal', vata: 0, pitta: 0, kapha: 3 }
    ]
  },
  {
    id: 39,
    category: 'Mental Traits',
    question: 'How do you express affection?',
    options: [
      { text: 'Verbally, frequently', vata: 3, pitta: 0, kapha: 0 },
      { text: 'Through actions and gifts', vata: 0, pitta: 3, kapha: 0 },
      { text: 'Through devotion and care', vata: 0, pitta: 0, kapha: 3 }
    ]
  },
  {
    id: 40,
    category: 'Mental Traits',
    question: 'How is your overall lifestyle?',
    options: [
      { text: 'Erratic, unpredictable', vata: 3, pitta: 0, kapha: 0 },
      { text: 'Busy, structured, goal-driven', vata: 0, pitta: 3, kapha: 0 },
      { text: 'Steady, regular, habitual', vata: 0, pitta: 0, kapha: 3 }
    ]
  }
];

export default PrakritiQuestions;